import { Alert, Box, Button, Icon, Stack } from "@mui/material";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { EmptyListMessage } from "../../../components/exports";
import { createSaleThunk } from "../../../slices/SalesSlice";
import { RootState } from "../../../slices/Store";
import ProjectDetailSaleItem from "../../sales/components/ProjectDetailSaleItem";

// updated
export default function ProjectDetailSales() {
    const projectDetailState = useSelector(
        (state: RootState) => state.projectDetail
    );

    const dispatch = useDispatch();
    const saleState = useSelector((state: RootState) => state.salesState);
    const [error, setError] = useState<string | null>(null);

    const addSale = async () => {
        const result = await createSaleThunk(
            {
                description: "",
                projectHashId: projectDetailState.projectHashId,
            },
            saleState,
            dispatch
        );

        if (result.error) {
            setError(result.error.getFirstError());
        }
    };

    const canCreateSale =
        projectDetailState.projectDetail.isVisited ||
        !projectDetailState.projectDetail.hasAvailableConstructor;

    return (
        <Stack spacing={2}>
            <EmptyListMessage
                condition={projectDetailState.sales.length === 0}
                message="فرایند فروش برای این پروژه ثبت نشده است"
            />

            {error && <Alert severity="error">{error}</Alert>}

            {projectDetailState.sales.map((s) => {
                return (
                    <ProjectDetailSaleItem
                        key={s.id}
                        sale={s}
                    />
                );
            })}

            <Box sx={{ display: "flex", justifyContent: "center" }}>
                <Button
                    variant="outlined"
                    onClick={addSale}
                    disabled={!canCreateSale}
                    startIcon={<Icon>add</Icon>}
                >
                    ایجاد فرایند فروش
                </Button>
            </Box>

            {!canCreateSale && (
                <Alert severity="error">
                    برای ثبت فرایند فروش باید اطاعات سازنده دریافت شده باشد
                </Alert>
            )}
        </Stack>
    );
}
